// import './utils/wdyr'; // <--- first import
import '@fontsource/poppins/400.css';
import '@fontsource/poppins/500.css';
import './index.css';
// eslint-disable-next-line import/extensions
import './utils/i18n.tsx';

import { CssBaseline, ThemeProvider } from '@mui/material';
import GlobalStyles from '@mui/material/GlobalStyles';
import { LicenseInfo } from '@mui/x-license';
import { StrictMode } from 'react';
import { CookiesProvider } from 'react-cookie';
import { createRoot } from 'react-dom/client';
import { HelmetProvider } from 'react-helmet-async';
import { Provider } from 'react-redux';
import { BrowserRouter, Routes } from 'react-router-dom';

import { ConfirmationDialogProvider } from './contexts/useConfirmationDialog';
import store from './redux/store';
import { generateRoutes, router } from './router';
import globalStyles from './utils/globalStyles';
import themeOptions from './utils/theme';

const inputGlobalStyles = <GlobalStyles styles={globalStyles} />;

LicenseInfo.setLicenseKey(import.meta.env.VITE_MUI_KEY || '');

createRoot(document.getElementById('root')!).render(
 <StrictMode>
  <BrowserRouter>
   <Provider store={store}>
    <CookiesProvider>
     <ThemeProvider theme={themeOptions()} disableTransitionOnChange>
      <ConfirmationDialogProvider>
       <CssBaseline enableColorScheme />

       {inputGlobalStyles}

       <HelmetProvider>
        <Routes>{generateRoutes(router)}</Routes>
       </HelmetProvider>
      </ConfirmationDialogProvider>
     </ThemeProvider>
    </CookiesProvider>
   </Provider>
  </BrowserRouter>
 </StrictMode>,
);
